import React from 'react';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import { FormattedDate } from 'react-intl';
import styled from 'styled-components/macro';
import BlogPanel from '@tovia/man-ui/lib/components/Blog/BlogPanel';

type Props = {
  className?: string;
  counts: Array<{ date: string; count: number }>;
};

export const ArchivePanel = (props: Props) => {
  const { className, counts } = props;

  return (
    <StyledBlogPanel headline="Archives" className={className}>
      <ul className="list-unstyled list-inline list">
        {counts.map(({ date, count }) => (
          <li key={date}>
            <NavLink to={`/blog/${date.replace('-', '')}01`}>
              <FormattedDate value={moment(date, 'YYYY-MM').toDate()} year="2-digit" month="long" />{' '}
              <small>({count})</small>
            </NavLink>
          </li>
        ))}
      </ul>
    </StyledBlogPanel>
  );
};

const StyledBlogPanel = styled(BlogPanel)`
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;

  & li {
    width: 33%;
    font-size: 0.85rem;
    line-height: 24px;
    padding: 0;

    @media (min-width: 992px) and (max-width: 1199px) {
      width: 47%;
    }

    @media (max-width: 479px) {
      width: 47%;
    }

    a {
      text-transform: capitalize;
      :hover {
        text-decoration: none;
      }

      @media screen and (max-width: 479px) {
        font-size: 0.85rem;
      }
    }
  }
`;
